<div class="page-layout-container ">
    <div class="row">
      <h1 class="title">Employees Monthly TimeSheet Report </h1>
    </div>
    <div *ngIf="!allEmployeesTimeSheetReport?.length" class="alert alert-warning">
      <p> For the employees who left the organisation update the fields - OnBoarding status, Employee last day in Manage
        Employee page </p>
      <p> For InActive employee if applicable contract end date should be Employee last day in the organisation</p>
      <p> Apply leaves for all the employees before generating the timesheet report </p>
      <p> Check whether contracts are up to date for all the employees</p>
    </div>
    <div *ngIf="message" class="alert alert-warning">{{ messageDesc }}</div>
    <div class="row">
      <div class="col-md-auto">
        <mat-form-field>
          <mat-label>Select Month for generating report</mat-label>
          <input matInput [matDatepicker]="leaveEndDate" required (dateChange)="fetchMonthlyReport($event)">
          <mat-datepicker-toggle matSuffix [for]="leaveEndDate"></mat-datepicker-toggle>
          <mat-datepicker #leaveEndDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col" *ngIf="allEmployeesTimeSheetReport?.length">
        <button mat-button (click)="monthlyTimeSheet()">
          Download Timesheet Report
        </button>
      </div>
    </div>
  
    <div>
  
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="search with Employee Name" #input>
      </mat-form-field>
  
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
        <ng-container matColumnDef="empId">
          <th mat-header-cell *matHeaderCellDef >Employee Name</th>
          <td mat-cell *matCellDef="let element"> {{element.empId}} </td>
        </ng-container>
  
        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef > Contract ID </th>
          <td mat-cell *matCellDef="let element"> {{element.contractId}} </td>
        </ng-container>
  
        <ng-container matColumnDef="contractPeriod">
          <th mat-header-cell *matHeaderCellDef > Contract Period </th>
          <td mat-cell *matCellDef="let element"> {{element.contractPeriod}} </td>
        </ng-container>
  
        <ng-container matColumnDef="contractType">
          <th mat-header-cell *matHeaderCellDef> Contract Type </th>
          <td mat-cell *matCellDef="let element"> {{element.contractType}} </td>
        </ng-container>
  
        <ng-container matColumnDef="totalWorkingDays">
          <th mat-header-cell *matHeaderCellDef > Total Working Days </th>
          <td mat-cell *matCellDef="let element"> {{element.totalWorkingDays}} </td>
        </ng-container>
  
        <ng-container matColumnDef="contractWorkingDays">
          <th mat-header-cell *matHeaderCellDef > Contract Working Days </th>
          <td mat-cell *matCellDef="let element"> {{element.contractWorkingDays}} </td>
        </ng-container>
  
        <ng-container matColumnDef="numberOfFilledHours">
          <th mat-header-cell *matHeaderCellDef> Number Of Filled Hours </th>
          <td mat-cell *matCellDef="let element"> {{element.numberOfFilledHours}} </td>
        </ng-container>
  
        <ng-container matColumnDef="filledDays">
          <th mat-header-cell *matHeaderCellDef> Filled Days </th>
          <td mat-cell *matCellDef="let element"> {{element.filledDays}} </td>
        </ng-container>
  
        <ng-container matColumnDef="numberOfLeaves">
          <th mat-header-cell *matHeaderCellDef> Number Of Leaves </th>
          <td mat-cell *matCellDef="let element"> {{element.numberOfLeaves}} </td>
        </ng-container>
  
        <ng-container matColumnDef="comments">
          <th mat-header-cell *matHeaderCellDef> Comments </th>
          <td mat-cell *matCellDef="let element"> {{element.comments}} </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{'row-bench': (row.contractType=='Bench')}"></tr>
      </table>
  
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  
    <app-progress [loading$]="loading$"> </app-progress>
  
  </div>